import { useCallback, useEffect } from 'react';
import { ExtendedProductDetailProduct } from 'shared/types/product/Product';
import { useGTM } from 'frontastic/hooks';
import { Cart } from 'shared/types/cart';

interface Options {
  product: ExtendedProductDetailProduct;
}

const useTrack = ({ product }: Options) => {
  const { viewItemEvent, addToCartEvent } = useGTM();

  const trackView = useCallback(async () => {
    viewItemEvent(product);
  }, [product]);

  useEffect(() => {
    trackView();
  }, []);

  const trackAddToCart = useCallback(
    async (cart: Cart) => {
      addToCartEvent(cart);
    },
    [addToCartEvent],
  );

  return { trackAddToCart, trackView };
};

export default useTrack;
